import React, { useState } from "react";
import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import { postApiFormData } from "../../helpers/AxiosInstance";
import { toast } from "react-toastify";
import useGetHook from "../../hooks/useGetHook";
import Spinner from "../../shared/Spinner";
import { useQueryClient } from "@tanstack/react-query";

const ThemeComponent = loadable(() => import("../../components/Setting"));

export default function CreateTheme() {
  const queryclient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const { data, isLoading: isThemeSettingLoading } = useGetHook({
    url: APIS.THEME_SETTING,
    queryKey: ["theme-setting"],
    params: {},
  });

  const handleCreate = async (values: any, setError: any) => {
    setIsLoading(true);
    const url = APIS.THEME_SETTING;
    const theme_settings = JSON.stringify(values?.theme_settings);
    const Json_ld = JSON.stringify(values?.json_ld);
    const formData = new FormData();
    formData.append("json_ld", Json_ld);
    formData.append("theme_settings", theme_settings);
    values?.logo && typeof values?.logo !== "string"
      ? formData.append("logo", values?.logo)
      : null;
    values?.favicon_icon && typeof values?.favicon_icon !== "string"
      ? formData.append("favicon_icon", values?.favicon_icon)
      : null;
    formData.append("title", values?.title);
    formData.append("code", values?.code);
    try {
      const res = await postApiFormData({ url, formData, setError });
      if (res?.status === 201) {
        toast.success("Updated Successfully");
        queryclient.refetchQueries();
      } else {
        toast.error(res?.data?.message ?? "Something went wrong");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return isThemeSettingLoading ? (
    <Spinner />
  ) : (
    <ThemeComponent
      handleCreate={handleCreate}
      isLoading={isLoading}
      themeSetting={data}
    />
  );
}
